<template>
    <base-alert>
        <template #header>Pravidla</template>
        <template #default>
            <ul class="mb-0">
                <li>Tipněte si u každého účastníka triatlonu jeho <strong>konečné umístění</strong>.</li>
                <li>Za každý správný tip je jeden bod.</li>
                <li>Kdo získá nejvíce bodů, vyhraje tipovací soutěž. V případě shodného počtu bodů rozhoduje datum a čas
                    zaslání tipů (kdo dřív pošle, v případě remízy vyhrává).
                </li>
                <li>Nelze tipnout stejné umístění dvěma a více závodníkům.</li>
                <li>Nutno tipnout umístění <strong>ke všem závodníkům</strong>, jinak je vaše tipování neplatné.</li>
                <li>Pro <strong>tři nejlepší tipaře</strong> bude přichystána <strong>basa Plzní</strong> (pro každého)
                </li>
            </ul>
            <div class="mt-2"><strong>Zasílání tipů uzavřeno 18.8.2021 23:59. Vyhodnocení proběhne po závodě</strong>
            </div>
        </template>
    </base-alert>
</template>

<script>
    import BaseAlert from "@/components/BaseAlert";

    export default {
        name: "CompetitionRules2021",
        components: {BaseAlert}
    };
</script>